const apiKey = "AIzaSyBDxdltx9sJNs-izcYulX1koifmxEL_RaA";
export default apiKey;
